module.exports = __webpack_public_path__ + "img/Intersection1.b960e22b.png";